var indexOf = [].indexOf;

import smoothScroll from 'smooth-scroll-into-view-if-needed';

angular.module('gym.bulkImports').directive('bulkImportReview', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/bulkImports/show/bulkImportReview.html.slim'),
    scope: {
      bulkImport: '=',
      membershipPlanCategories: '=',
      visible: '=',
      locked: '=',
      next: '&'
    },
    controller: ["$scope", "$rootScope", "$modal", "$http", "$stateParams", "$timeout", "$q", "$window", "ngTableParams", "MembershipPlanCategories", "MessageService", "loadingAnimation", "flash", "MembershipPlans", "MembershipPlanService", "MembershipIntervalUnits", function($scope, $rootScope, $modal, $http, $stateParams, $timeout, $q, $window, ngTableParams, MembershipPlanCategories, MessageService, loadingAnimation, flash, MembershipPlans, MembershipPlanService, MembershipIntervalUnits) {
      var checkInvalidRows, saveRow;
      $scope.loadingMembershipPlans = true;
      $scope.isEditMode = false;
      $scope.editedRowIds = [];
      $scope.columns = $scope.bulkImport.all('columns').getList({
        count: 1000
      }).$object;
      $scope.scrollToBeginningOfTable = function() {
        var tableContainer;
        tableContainer = document.querySelector('.table-container');
        if (tableContainer) {
          return tableContainer.scrollLeft = 0;
        }
      };
      $scope.scrollToElement = function(elementId) {
        var element;
        if (elementId) {
          element = document.getElementById(elementId);
          if (element) {
            return smoothScroll(element, {
              behavior: 'instant',
              block: 'center',
              inline: 'center'
            });
          }
        } else {
          return $scope.scrollToBeginningOfTable();
        }
      };
      $scope.$watch('visible', function(visible, previousVisible) {
        if (visible && !previousVisible && $scope.tableParams) {
          $scope.columns = $scope.bulkImport.all('columns').getList({
            count: 1000
          }).$object;
          $scope.tableParams.reload();
          return checkInvalidRows();
        }
      });
      $scope.onBulkImportMultipleSelectChange = function(selectedValues, row, rowContentIndex) {
        if (rowContentIndex >= 0 && rowContentIndex < row.row_content.length) {
          row.row_content[rowContentIndex] = selectedValues.join(',');
          return row.editable_row_content[rowContentIndex].value = selectedValues.join(',');
        }
      };
      $scope.bulkUpdate = function(row, columnId) {
        var url;
        loadingAnimation.show();
        url = `/gyms/${$stateParams.gymId}/bulk_import/bulk_imports/${$stateParams.id}/columns/${columnId}/bulk_set_membership_value}`;
        return $http.put(url).then(function(response) {
          if (row) {
            row.row_content = response.data.row_content;
            return $timeout(function() {
              $scope.$apply();
              return loadingAnimation.hide();
            }, 0);
          }
        });
      };
      $scope.currentMembershipPlanSelected = null;
      $scope.isMembershipImport = $scope.bulkImport.import_type === 'membership';
      MembershipPlans.getList({
        count: 400
      }).then(function(membershipPlans) {
        $scope.membershipPlans = membershipPlans;
        return $scope.loadingMembershipPlans = false;
      });
      $scope.onMembershipPlanSelected = function(membershipPlan, row) {
        angular.forEach(row.row_content, function(content, index) {
          var column, ref;
          column = $scope.columns[index];
          if ((column != null ? column.mapped_to_field_name : void 0) && (ref = column.mapped_to_field_name, indexOf.call(membershipPlan, ref) >= 0)) {
            return row.row_content[index] = membershipPlan[column.mapped_to_field_name];
          }
        });
        return $timeout(function() {
          return $scope.$apply();
        }, 0);
      };
      $scope.getFullContactName = function(row) {
        return `${row.contact_first_name} ${row.contact_last_name}`;
      };
      $scope.filters = {};
      checkInvalidRows = function() {
        var invalidRowsCountParams, unignoredRows;
        if (!$scope.visible) {
          return;
        }
        invalidRowsCountParams = {
          count: 0,
          'filters[invalid_only]': true,
          'filters[not_ignored]': true
        };
        unignoredRows = {
          count: 0,
          'filters[not_ignored]': true
        };
        $scope.bulkImport.all('rows').getList(invalidRowsCountParams).then(function(response) {
          return $scope.invalidRowsCount = response.meta.total;
        });
        return $scope.bulkImport.all('rows').getList(unignoredRows).then(function(response) {
          return $scope.validRowsCount = response.meta.total;
        });
      };
      checkInvalidRows();
      $scope.onFiltersChange = function() {
        return $scope.tableParams.reload();
      };
      $scope.tableParams = new ngTableParams({
        page: 1,
        count: 100
      }, {
        counts: [],
        total: 0,
        getData: function($defer, $params) {
          var params;
          if (!$scope.visible) {
            return;
          }
          loadingAnimation.show();
          params = $params.url();
          if ($scope.filters.displayOnly === 'invalid') {
            params['filters[invalid_only]'] = true;
          }
          if ($scope.filters.displayOnly === 'ignored') {
            params['filters[ignored_only]'] = true;
          }
          return $scope.bulkImport.all('rows').getList(params).then(function(data) {
            $params.total(data.meta.total);
            $defer.resolve(data);
            return loadingAnimation.hide();
          });
        }
      });
      saveRow = function(row, reloadTable) {
        var deferred, item, rowCopy;
        deferred = $q.defer();
        rowCopy = row.clone();
        rowCopy.rootObjectName = 'bulk_import_row';
        row.loading = true;
        $scope.isEditMode = $scope.editedRowIds.length > 0;
        if (rowCopy.editable_row_content) {
          rowCopy.row_content = (function() {
            var i, len, ref, results;
            ref = rowCopy.editable_row_content;
            results = [];
            for (i = 0, len = ref.length; i < len; i++) {
              item = ref[i];
              results.push(item.value);
            }
            return results;
          })();
          rowCopy.editable_row_content = row.editable_row_content;
        }
        rowCopy.save().then(function(response) {
          row.loading = false;
          angular.extend(row, response.plain());
          checkInvalidRows();
          row.editable_row_content = void 0;
          return deferred.resolve();
        }).catch(function() {
          row.loading = false;
          return deferred.reject();
        });
        return deferred.promise;
      };
      $scope.isReady = function() {
        return !$scope.invalidRowsCount && $scope.validRowsCount;
      };
      $scope.edit = function(row, elementId) {
        $scope.isEditMode = true;
        $timeout(function() {
          return $scope.scrollToElement(elementId);
        }, 0);
        $scope.editedRowIds.push(row.id);
        if (!row.editable_row_content) {
          return row.editable_row_content = angular.copy(row.row_content).map(function(value) {
            return {
              value: value
            };
          });
        }
      };
      $scope.saveEdit = function(row) {
        var index;
        $scope.isEditMode = false;
        index = $scope.editedRowIds.indexOf(row.id);
        if (index !== -1) {
          $scope.editedRowIds.splice(index, 1);
        }
        if (row.editable_row_content != null) {
          row.row_content = angular.copy(row.editable_row_content).map(function(item) {
            return item.value;
          });
        }
        return saveRow(row);
      };
      $scope.undoEdit = function(row) {
        var index;
        index = $scope.editedRowIds.indexOf(row.id);
        if (index !== -1) {
          $scope.editedRowIds.splice(index, 1);
        }
        if ($scope.editedRowIds.length === 0) {
          $scope.isEditMode = false;
        }
        return row.editable_row_content = void 0;
      };
      $scope.ignore = function(row) {
        var message;
        message = "This will exclude the selected row from this import. Are you sure?";
        if ($window.confirm(message)) {
          row.ignored = true;
          return saveRow(row);
        }
      };
      $scope.undoIgnore = function(row) {
        row.ignored = false;
        return saveRow(row);
      };
      $scope.confirm = function() {
        var message;
        if ($scope.isEditMode) {
          $modal.open({
            template: require('templates/gyms/bulkImports/show/bulkImportIsEditModeWarningModal.html.slim'),
            controller: ["$scope", "$modalInstance", function($scope, $modalInstance) {
              return $scope.cancel = function() {
                return $modalInstance.dismiss();
              };
            }]
          });
        } else {
          message = "By proceeding, you agree that this import will generate " + `${$scope.validRowsCount} records. Are you sure you want to continue?`;
          if ($window.confirm(message)) {
            return $scope.next();
          }
        }
      };
      $scope.changeColumn = function(column) {
        var message;
        if ($scope.bulkImport.row_validation_in_progress) {
          message = ['Additional changes cannot be made while row validation is in progress.', 'Please wait for validation to finish before applying more changes.'];
          MessageService.message({
            title: 'Action unavailable',
            message: message
          });
          return;
        }
        return $modal.open({
          template: require('templates/gyms/bulkImports/show/bulkImportChangeColumnModal.html.slim'),
          resolve: {
            bulkUpdate: function() {
              return $scope.bulkUpdate;
            },
            column: function() {
              return column;
            },
            categories: function() {
              return $scope.membershipPlanCategories;
            },
            checkInvalidRows: function() {
              return checkInvalidRows;
            },
            reloadTable: function() {
              return $scope.tableReload;
            }
          },
          controller: 'BulkUpdateImportChangeColumn'
        });
      };
      $scope.tableReload = function() {
        return $scope.tableParams.reload();
      };
      $scope.showPageRange = function() {
        var prevPagesCount, startingCount, total;
        total = $scope.tableParams.total();
        prevPagesCount = ($scope.tableParams.page() - 1) * $scope.tableParams.count();
        startingCount = total ? prevPagesCount + 1 : total;
        return `${startingCount} - ${prevPagesCount + $scope.tableParams.data.length}`;
      };
      $scope.getContentLabel = function(content, column, row, rowIndex) {
        var ids, items, labels, match;
        if (column != null ? column.foreign_key_dropdown : void 0) {
          match = _.find(column.foreign_key_dropdown_options, function(option) {
            return option[1] === +content || option[0] === content;
          });
          return (match != null ? match[0] : void 0) || content;
        } else if (column != null ? column.foreign_key_multi_dropdown : void 0) {
          items = content.split(',').map(function(item) {
            return item.trim();
          });
          labels = [];
          ids = [];
          _.each(items, function(item) {
            if (/^\d+$/.test(item)) {
              match = _.find(column.foreign_key_multi_dropdown_options, function(option) {
                return option.id === +item;
              });
              if (match != null ? match.name : void 0) {
                labels.push(match.name);
              }
              return ids.push(item);
            } else {
              match = _.find(column.foreign_key_multi_dropdown_options, function(option) {
                return option.name.toLowerCase() === item.toLowerCase();
              });
              if (match != null ? match.id : void 0) {
                ids.push(match.id);
                return labels.push(match.name);
              }
            }
          });
          row.row_content[rowIndex] = ids.join(', ');
          return labels.join(', ');
        } else {
          return content;
        }
      };
      $scope.getContentValue = function(content, options) {
        var match;
        match = _.find(options, function(option) {
          return option[1] === +content.value || option[0] === content.value;
        });
        if (match) {
          return content.value = match[1];
        }
      };
      $scope.updateRow = function(row, val) {
        var membershipPlanId, url;
        membershipPlanId = val;
        if (membershipPlanId != null) {
          url = `/gyms/${$stateParams.gymId}/bulk_import/bulk_imports/${$stateParams.id}/rows/${row.id}/select_membership_plan?membership_plan_id=${val}`;
          return $http.put(url).then(function(response) {
            var index, updatedRowContent;
            updatedRowContent = response.data.row_content;
            row.row_content[0] = +updatedRowContent[0];
            angular.forEach(row.row_content, function(content, index) {
              return row.row_content[index] = updatedRowContent[index];
            });
            angular.forEach(row.editable_row_content, function(content, index) {
              return row.editable_row_content[index].value = updatedRowContent[index];
            });
            index = $scope.editedRowIds.indexOf(row.id);
            if (index !== -1) {
              $scope.editedRowIds.splice(index, 1);
            }
            return saveRow(row);
          });
        }
      };
      return $scope.handleKeyDown = function(event, row) {
        var index;
        if (event.keyCode === 13 && $scope.isEditMode) {
          index = $scope.editedRowIds.indexOf(row.id);
          if (index !== -1) {
            $scope.editedRowIds.splice(index, 1);
          }
          return saveRow(row);
        }
      };
    }]
  };
});
